var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _g, _path8, _rect3, _g2, _path9, _path10, _rect4, _g3, _path11, _rect5, _path12, _rect6, _rect7, _g4, _path13, _rect8, _g5, _path14, _path15, _rect9, _g6, _path16, _rect10, _path17, _rect11, _rect12, _g7, _path18, _rect13, _g8, _path19, _path20, _rect14, _g9, _path21, _rect15, _path22, _rect16, _rect17, _g10, _path23, _rect18, _g11, _path24, _path25, _rect19, _g12, _path26, _rect20, _path27, _rect21, _rect22, _g13, _path28, _rect23, _g14, _path29, _path30, _rect24, _g15, _path31, _rect25, _path32, _rect26, _rect27, _g16, _path33, _rect28, _g17, _path34, _path35, _rect29, _g18, _path36, _rect30, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeBeaker6Tubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 259,
    viewBox: "0 0 209 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.397 97.5829C174.747 98.916 173.212 99.6006 171.767 99.2043L169.853 98.6638C164.5 101 164 103 163.839 110V252.839C163.839 256.208 161.094 258.946 157.716 258.946L39.4562 259C36.061 259 33 256.498 33 253.129V92C33 89.55 32.5934 87.3684 31.2209 85.3147C30.4985 83.7655 31.6363 82 33.352 82H153.689C161.401 82 168.769 85.1526 174.079 90.7012C176.011 92.4487 176.553 95.259 175.397 97.5829Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8751 149L107.142 148.949C110.373 148.949 113 146.341 113 143.133V113.5C85.1972 112.539 70.5 108.5 35 108.5L35 143.167C35 146.392 37.6265 149 40.8751 149Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3461 84H37.7872C37.1132 84 36.5667 84.4478 36.5667 85C36.5667 85.5522 37.1132 86 37.7872 86H63.3461C64.0201 86 64.5667 85.5522 64.5667 85C64.5667 84.4478 64.0201 84 63.3461 84Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.21 84H73.7899C72.2492 84 71 84.4478 71 85C71 85.5522 72.2492 86 73.7899 86H132.21C133.751 86 135 85.5522 135 85C135 84.4478 133.751 84 132.21 84Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 117V249.165C35 252.401 37.6242 255.017 40.8699 255L156.078 254.948C159.307 254.948 162 252.219 162 249V109C162 108.415 161.965 107.585 162 107C134.757 107.258 73 117 35 117Z",
    fill: "#66CEF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7024 107H47.2976C46.0274 107 45 108.393 45 110.116V250.921C45 253.176 46.345 255 48.0075 255H56.9925C58.655 255 60 253.176 60 250.921V110.116C60 108.393 58.9726 107 57.7024 107Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 248.051C39 248.578 39.4444 249 40 249C40.0743 249 40.1466 248.992 40.2161 248.978C40.2821 248.993 40.3507 249 40.4212 249H48.8191C49.3428 249 49.7763 248.556 49.7943 248C49.7943 247.444 49.3609 247 48.8191 247H41V232H48.8191C49.3428 232 49.7763 231.556 49.7943 231C49.7943 230.444 49.3609 230 48.8191 230H41V215H48.8191C49.3428 215 49.7763 214.556 49.7943 214C49.7943 213.444 49.3609 213 48.8191 213H41V198H48.8191C49.3428 198 49.7763 197.556 49.7943 197C49.7943 196.444 49.3609 196 48.8191 196H41V181H48.8191C49.3428 181 49.7763 180.556 49.7943 180C49.7943 179.444 49.3609 179 48.8191 179H41V164H48.8191C49.3428 164 49.7763 163.556 49.7943 163C49.7943 162.444 49.3609 162 48.8191 162H41V147H48.8191C49.3428 147 49.7763 146.556 49.7943 146C49.7943 145.444 49.3609 145 48.8191 145H41V130H48.8191C49.3428 130 49.7763 129.556 49.7943 129C49.7943 128.444 49.3609 128 48.8191 128H41V113H49.373C49.8968 113 50.3302 112.556 50.3483 112C50.3483 111.444 49.9148 111 49.373 111H41V96H49.373C49.8968 96 50.3302 95.5556 50.3483 95C50.3483 94.4445 49.9148 94 49.373 94H40.9751C40.802 94 40.64 94.0454 40.4996 94.1253C40.3529 94.0455 40.1824 94 40 94C39.4444 94 39 94.4218 39 94.949V248.051Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.318,
    y: 141.104,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-105 54.318 141.104)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 117,
    width: 38,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7322,
    y: 138.655,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-105 55.7322 138.655)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.7322,
    y: 138.655,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-105 55.7322 138.655)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9367 135.21C58.264 136.194 54.489 134.015 53.5049 130.342C52.5208 126.669 54.7003 122.894 58.373 121.91L89.3694 113.605L91.8978 123.041C92.4696 125.175 91.2032 127.368 89.0694 127.94L61.9367 135.21Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6945 127.581L49.918 124.683L89.521 114.072L90.2974 116.97L50.6945 127.581Z",
    fill: "#F2F7FC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3391 137.827C46.8359 138.488 45.7924 138.283 45.5773 137.48L44.0168 131.657C43.8104 130.886 44.5448 130.196 45.301 130.45L49.921 132.001L50.4029 133.8L47.3391 137.827Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 130,
    width: 4,
    height: 5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0098,
    y: 130.156,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(75 52.0098 130.156)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.0098,
    y: 130.156,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(75 52.0098 130.156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1161 130.021C50.4265 129.938 50.7522 130.077 50.8883 130.368C51.1062 130.834 51.427 131.597 51.6682 132.497C51.9094 133.397 52.013 134.218 52.0572 134.73C52.0849 135.05 51.8723 135.334 51.5619 135.417C51.188 135.517 50.8036 135.295 50.7034 134.921L49.6205 130.879C49.5203 130.505 49.7422 130.121 50.1161 130.021Z",
    fill: "#EEEEEE"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5503 138.043C43.9827 138.454 43.1788 138.169 42.9974 137.492L41.7957 133.007C41.6217 132.358 42.1251 131.725 42.7969 131.749L49.921 132.001L50.4029 133.8L44.5503 138.043Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.258 123.647C101.025 123.969 101.826 123.269 101.611 122.466L100.05 116.642C99.8437 115.872 98.8625 115.641 98.3346 116.239L95.1091 119.893L95.5911 121.691L100.258 123.647Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 118,
    width: 4,
    height: 6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(0.258819 0.965926 0.965926 -0.258819 92.3778 119.339)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(0.258819 0.965926 0.965926 -0.258819 92.3778 119.339)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9502 118.276C93.6398 118.359 93.4272 118.642 93.4549 118.962C93.4991 119.475 93.6027 120.296 93.8439 121.196C94.0851 122.096 94.4059 122.859 94.6238 123.324C94.7599 123.616 95.0856 123.755 95.396 123.671C95.7699 123.571 95.9918 123.187 95.8916 122.813L94.8087 118.771C94.7085 118.397 94.3241 118.175 93.9502 118.276Z",
    fill: "#EEEEEE"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 122.44C103.479 122.512 104.032 121.864 103.851 121.186L102.649 116.702C102.475 116.052 101.723 115.756 101.153 116.113L95.1092 119.893L95.5911 121.691L102.781 122.44Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7052,
    y: 116.47,
    width: 18,
    height: 12,
    transform: "rotate(75 76.7052 116.47)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8491 131.48L72.5914 130.518L74.5271 129.999L73.0332 124.424C72.5052 125.05 71.7882 125.341 71.0178 125.573L70.7756 124.669C71.7631 124.367 72.3778 123.879 72.7193 123.067L73.6929 122.806L75.5471 129.726L77.4828 129.207L77.7406 130.169L72.8491 131.48Z",
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 143,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 101 143)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 127,
    width: 38,
    height: 14
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 141,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 103 141)",
    fill: "#99DFF9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 141,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 103 141)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.885 139.279C106.082 139.279 103 136.197 103 132.394C103 128.592 106.082 125.51 109.885 125.51L141.974 125.51L141.974 135.279C141.974 137.488 140.183 139.279 137.974 139.279L109.885 139.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 129L101 126L142 126L142 129L101 129Z",
    fill: "#F2F7FC"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1072 138.028C94.45 138.537 93.4951 138.068 93.4951 137.237L93.4951 131.208C93.4951 130.411 94.3832 129.934 95.0479 130.375L99.109 133.069L99.109 134.931L95.1072 138.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 131,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 131.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 131.828)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 131.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 131.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8098 131.207C100.131 131.207 100.41 131.425 100.466 131.742C100.556 132.248 100.668 133.068 100.668 134C100.668 134.932 100.556 135.752 100.466 136.258C100.41 136.574 100.131 136.793 99.8098 136.793C99.4227 136.793 99.1089 136.479 99.1089 136.092L99.1089 131.908C99.1089 131.521 99.4227 131.207 99.8098 131.207Z",
    fill: "#EEEEEE"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3574 137.515C91.7027 137.766 91 137.282 91 136.581L91 131.938C91 131.266 91.65 130.785 92.2928 130.982L99.1089 133.069L99.1089 134.931L92.3574 137.515Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.893 138.028C150.55 138.537 151.505 138.068 151.505 137.237L151.505 131.208C151.505 130.411 150.617 129.934 149.952 130.375L145.891 133.069L145.891 134.931L149.893 138.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 131,
    width: 3,
    height: 6
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 131.828)",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 131.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19 131.207C144.869 131.207 144.59 131.425 144.534 131.742C144.444 132.248 144.332 133.068 144.332 134C144.332 134.932 144.444 135.752 144.534 136.258C144.59 136.574 144.869 136.793 145.19 136.793C145.577 136.793 145.891 136.479 145.891 136.092L145.891 131.908C145.891 131.521 145.577 131.207 145.19 131.207Z",
    fill: "#EEEEEE"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.643 137.515C153.297 137.766 154 137.282 154 136.581L154 131.938C154 131.266 153.35 130.785 152.707 130.982L145.891 133.069L145.891 134.931L152.643 137.515Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 125,
    width: 18,
    height: 12,
    transform: "rotate(90 129 125)",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.695 138.5L120.695 137.888C120.695 136.376 121.415 135.476 123.323 134.6C124.763 133.94 125.267 133.4 125.267 132.548C125.267 131.696 124.727 131.156 123.599 131.156C122.459 131.156 121.847 131.696 121.847 132.788L121.847 132.956L120.815 132.956L120.815 132.68C120.815 131.072 121.835 130.196 123.611 130.196C125.387 130.196 126.323 131.096 126.323 132.524C126.323 133.82 125.639 134.612 123.827 135.428C122.327 136.1 121.787 136.628 121.739 137.504L126.299 137.504L126.299 138.5L120.695 138.5Z",
    fill: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 161,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 55 161)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 145,
    width: 38,
    height: 14
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 159,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 57 159)",
    fill: "#99DFF9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 159,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 57 159)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8846 157.279C60.0823 157.279 57 154.197 57 150.394C57 146.592 60.0823 143.51 63.8846 143.51L95.9744 143.51L95.9744 153.279C95.9744 155.488 94.1835 157.279 91.9744 157.279L63.8846 157.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 147L55 144L96 144L96 147L55 147Z",
    fill: "#F2F7FC"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1072 156.028C48.45 156.537 47.4951 156.068 47.4951 155.237L47.4951 149.208C47.4951 148.411 48.3832 147.934 49.0479 148.375L53.109 151.069L53.109 152.931L49.1072 156.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 149,
    width: 3,
    height: 6
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 55.604,
    y: 149.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 55.604 149.828)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.604,
    y: 149.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 55.604 149.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8098 149.207C54.1312 149.207 54.4099 149.426 54.466 149.742C54.5559 150.248 54.6683 151.068 54.6683 152C54.6683 152.932 54.5559 153.752 54.466 154.258C54.4099 154.575 54.1312 154.793 53.8098 154.793C53.4227 154.793 53.1089 154.479 53.1089 154.092L53.1089 149.908C53.1089 149.521 53.4227 149.207 53.8098 149.207Z",
    fill: "#EEEEEE"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3574 155.515C45.7027 155.766 45 155.282 45 154.581L45 149.938C45 149.266 45.65 148.785 46.2928 148.982L53.1089 151.069L53.1089 152.931L46.3574 155.515Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.893 156.028C104.55 156.537 105.505 156.068 105.505 155.237L105.505 149.208C105.505 148.411 104.617 147.934 103.952 148.375L99.891 151.069L99.891 152.931L103.893 156.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 149,
    width: 3,
    height: 6
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 97.396 149.828)",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 97.396 149.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1902 149.207C98.8688 149.207 98.5901 149.426 98.534 149.742C98.4441 150.248 98.3317 151.068 98.3317 152C98.3317 152.932 98.4441 153.752 98.534 154.258C98.5901 154.575 98.8688 154.793 99.1902 154.793C99.5773 154.793 99.8911 154.479 99.8911 154.092L99.8911 149.908C99.8911 149.521 99.5773 149.207 99.1902 149.207Z",
    fill: "#EEEEEE"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.643 155.515C107.297 155.766 108 155.282 108 154.581L108 149.938C108 149.266 107.35 148.785 106.707 148.982L99.8911 151.069L99.8911 152.931L106.643 155.515Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 143,
    width: 18,
    height: 12,
    transform: "rotate(90 83 143)",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5386 156.644C75.6666 156.644 74.6706 155.84 74.6706 154.34L74.6706 154.04L75.7026 154.04L75.7026 154.196C75.7026 155.18 76.3146 155.684 77.5386 155.684C78.7026 155.684 79.3506 155.228 79.3506 154.232C79.3506 153.296 78.7746 152.816 77.5146 152.816L76.6146 152.816L76.6146 151.856L77.5266 151.856C78.5946 151.856 79.1586 151.412 79.1586 150.536C79.1586 149.636 78.5706 149.156 77.5146 149.156C76.4106 149.156 75.8106 149.684 75.8106 150.632L75.8106 150.74L74.7906 150.74L74.7906 150.56C74.7906 149.06 75.7986 148.196 77.5506 148.196C79.2306 148.196 80.2026 149 80.2026 150.44C80.2026 151.328 79.8306 151.94 79.0986 152.252L79.0986 152.276C79.9866 152.576 80.4066 153.236 80.4066 154.268C80.4066 155.864 79.3866 156.644 77.5386 156.644Z",
    fill: "#333333"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 104.659,
    y: 173.975,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-75 104.659 173.975)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 160,
    width: 38,
    height: 21
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 107.109,
    y: 172.561,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-75 107.109 172.561)",
    fill: "#99DFF9"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.109,
    y: 172.561,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-75 107.109 172.561)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.204 172.68C110.531 171.696 108.352 167.921 109.336 164.248C110.32 160.575 114.095 158.396 117.768 159.38L148.764 167.685L146.236 177.122C145.664 179.256 143.471 180.522 141.337 179.95L114.204 172.68Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.283 160.452L109.059 157.554L148.662 168.166L147.886 171.063L108.283 160.452Z",
    fill: "#F2F7FC"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.254 167.647C99.4874 167.969 98.6863 167.269 98.9014 166.466L100.462 160.642C100.668 159.872 101.649 159.641 102.177 160.239L105.403 163.893L104.921 165.691L100.254 167.647Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 162,
    width: 4,
    height: 6
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 108.134,
    y: 163.339,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(105 108.134 163.339)",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.134,
    y: 163.339,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(105 108.134 163.339)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.562 162.276C106.872 162.359 107.085 162.642 107.057 162.962C107.013 163.475 106.909 164.296 106.668 165.196C106.427 166.096 106.106 166.859 105.888 167.324C105.752 167.616 105.426 167.755 105.116 167.671C104.742 167.571 104.52 167.187 104.62 166.813L105.703 162.771C105.804 162.397 106.188 162.175 106.562 162.276Z",
    fill: "#EEEEEE"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7307 166.44C97.0334 166.512 96.4798 165.864 96.6612 165.186L97.8629 160.702C98.0369 160.052 98.7891 159.756 99.3591 160.113L105.403 163.893L104.921 165.691L97.7307 166.44Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.173 181.827C153.676 182.488 154.72 182.283 154.935 181.48L156.495 175.657C156.702 174.886 155.967 174.196 155.211 174.45L150.591 176.001L150.109 177.8L153.173 181.827Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 174,
    width: 4,
    height: 5
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 148.502 174.156)",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 148.502 174.156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.396 174.021C150.086 173.938 149.76 174.077 149.624 174.368C149.406 174.834 149.085 175.597 148.844 176.497C148.603 177.397 148.499 178.218 148.455 178.73C148.427 179.05 148.64 179.334 148.95 179.417C149.324 179.517 149.708 179.295 149.809 178.921L150.892 174.879C150.992 174.505 150.77 174.121 150.396 174.021Z",
    fill: "#EEEEEE"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.962 182.043C156.529 182.454 157.333 182.169 157.515 181.492L158.716 177.007C158.89 176.358 158.387 175.725 157.715 175.749L150.591 176.001L150.109 177.8L155.962 182.043Z",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 136.364,
    y: 163.835,
    width: 18,
    height: 12,
    transform: "rotate(105 136.364 163.835)",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.638 175.741L129.122 173.933L125.065 172.846L125.329 171.861L130.611 167.822L131.77 168.133L130.391 173.279L131.318 173.527L131.07 174.455L130.142 174.206L129.658 176.014L128.638 175.741ZM126.461 172.226L129.371 173.006L130.396 169.181L126.461 172.226Z",
    fill: "#333333"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 187,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 54 187)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 171,
    width: 38,
    height: 14
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 185,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 56 185)",
    fill: "#99DFF9"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 185,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 56 185)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8846 183.279C59.0823 183.279 56 180.197 56 176.394C56 172.592 59.0823 169.51 62.8846 169.51L94.9744 169.51L94.9744 179.279C94.9744 181.488 93.1835 183.279 90.9744 183.279L62.8846 183.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 173L54 170L95 170L95 173L54 173Z",
    fill: "#F2F7FC"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1072 182.028C47.45 182.537 46.4951 182.068 46.4951 181.237L46.4951 175.208C46.4951 174.411 47.3832 173.934 48.0479 174.375L52.109 177.069L52.109 178.931L48.1072 182.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 175,
    width: 3,
    height: 6
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 175.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 54.604 175.828)",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 175.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 54.604 175.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8098 175.207C53.1312 175.207 53.4099 175.426 53.466 175.742C53.5559 176.248 53.6683 177.068 53.6683 178C53.6683 178.932 53.5559 179.752 53.466 180.258C53.4099 180.575 53.1312 180.793 52.8098 180.793C52.4227 180.793 52.1089 180.479 52.1089 180.092L52.1089 175.908C52.1089 175.521 52.4227 175.207 52.8098 175.207Z",
    fill: "#EEEEEE"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3574 181.515C44.7027 181.766 44 181.282 44 180.581L44 175.938C44 175.266 44.65 174.785 45.2928 174.982L52.1089 177.069L52.1089 178.931L45.3574 181.515Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.893 182.028C103.55 182.537 104.505 182.068 104.505 181.237L104.505 175.208C104.505 174.411 103.617 173.934 102.952 174.375L98.891 177.069L98.891 178.931L102.893 182.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 175,
    width: 3,
    height: 6
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 96.396 175.828)",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 96.396 175.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1902 175.207C97.8688 175.207 97.5901 175.426 97.534 175.742C97.4441 176.248 97.3317 177.068 97.3317 178C97.3317 178.932 97.4441 179.752 97.534 180.258C97.5901 180.575 97.8688 180.793 98.1902 180.793C98.5773 180.793 98.8911 180.479 98.8911 180.092L98.8911 175.908C98.8911 175.521 98.5773 175.207 98.1902 175.207Z",
    fill: "#EEEEEE"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.643 181.515C106.297 181.766 107 181.282 107 180.581L107 175.938C107 175.266 106.35 174.785 105.707 174.982L98.8911 177.069L98.8911 178.931L105.643 181.515Z",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 169,
    width: 18,
    height: 12,
    transform: "rotate(90 82 169)",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5146 182.644C74.7026 182.644 73.7066 181.792 73.6826 180.388L74.7146 180.388C74.7506 181.204 75.4106 181.684 76.5026 181.684C77.7146 181.684 78.3866 181.096 78.3866 179.908C78.3866 178.744 77.7386 178.132 76.5866 178.132C75.9266 178.132 75.3986 178.336 74.9186 178.756L73.9466 178.756L74.2226 174.34L79.0706 174.34L79.0706 175.336L75.1706 175.336L75.0146 177.748C75.4946 177.364 76.0946 177.172 76.8266 177.172C78.4826 177.172 79.4426 178.132 79.4426 179.884C79.4426 181.732 78.3866 182.644 76.5146 182.644Z",
    fill: "#333333"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 203,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 101 203)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 187,
    width: 38,
    height: 14
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 103 201)",
    fill: "#99DFF9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 103 201)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.885 199.279C106.082 199.279 103 196.197 103 192.394C103 188.592 106.082 185.51 109.885 185.51L141.974 185.51L141.974 195.279C141.974 197.488 140.183 199.279 137.974 199.279L109.885 199.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 189L101 186L142 186L142 189L101 189Z",
    fill: "#F2F7FC"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1072 198.028C94.45 198.537 93.4951 198.068 93.4951 197.237L93.4951 191.208C93.4951 190.411 94.3832 189.934 95.0479 190.375L99.109 193.069L99.109 194.931L95.1072 198.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 191,
    width: 3,
    height: 6
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 191.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 191.828)",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 191.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 191.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8098 191.207C100.131 191.207 100.41 191.426 100.466 191.742C100.556 192.248 100.668 193.068 100.668 194C100.668 194.932 100.556 195.752 100.466 196.258C100.41 196.575 100.131 196.793 99.8098 196.793C99.4227 196.793 99.1089 196.479 99.1089 196.092L99.1089 191.908C99.1089 191.521 99.4227 191.207 99.8098 191.207Z",
    fill: "#EEEEEE"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3574 197.515C91.7027 197.766 91 197.282 91 196.581L91 191.938C91 191.266 91.65 190.785 92.2928 190.982L99.1089 193.069L99.1089 194.931L92.3574 197.515Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M149.893 198.028C150.55 198.537 151.505 198.068 151.505 197.237L151.505 191.208C151.505 190.411 150.617 189.934 149.952 190.375L145.891 193.069L145.891 194.931L149.893 198.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_8036_79205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 191,
    width: 3,
    height: 6
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 191.828)",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_8036_79205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 191.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19 191.207C144.869 191.207 144.59 191.426 144.534 191.742C144.444 192.248 144.332 193.068 144.332 194C144.332 194.932 144.444 195.752 144.534 196.258C144.59 196.575 144.869 196.793 145.19 196.793C145.577 196.793 145.891 196.479 145.891 196.092L145.891 191.908C145.891 191.521 145.577 191.207 145.19 191.207Z",
    fill: "#EEEEEE"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.643 197.515C153.297 197.766 154 197.282 154 196.581L154 191.938C154 191.266 153.35 190.785 152.707 190.982L145.891 193.069L145.891 194.931L152.643 197.515Z",
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 185,
    width: 18,
    height: 12,
    transform: "rotate(90 129 185)",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M123.611 198.644C121.787 198.644 120.755 197.696 120.755 195.872L120.755 192.98C120.755 191.168 121.763 190.196 123.635 190.196C125.315 190.196 126.251 190.964 126.311 192.404L125.279 192.404C125.207 191.576 124.655 191.156 123.647 191.156C122.411 191.156 121.811 191.78 121.811 193.04L121.811 194.192C122.315 193.604 123.023 193.316 123.923 193.316C125.507 193.316 126.419 194.216 126.419 195.92C126.419 197.672 125.459 198.644 123.611 198.644ZM123.611 197.684C124.787 197.684 125.351 197.072 125.351 195.944C125.351 194.852 124.811 194.276 123.731 194.276C122.807 194.276 122.159 194.708 121.811 195.572L121.811 195.848C121.811 197.084 122.435 197.684 123.611 197.684Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBeaker6Tubes);
export default __webpack_public_path__ + "static/media/Large_Beaker_6Tubes.812dfbf7dfc3dae738988727f2cbec67.svg";
export { ForwardRef as ReactComponent };